export const Pagination = () => (
  <div className="pagination">
    <a href="" className="pagination__item first">
      <svg
        width="13.000000"
        height="11.666748"
        viewBox="0 0 13 11.6667"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <path
          id="Vector (Stroke)"
          d="M6.34 0.7C6.62 0.97 6.62 1.41 6.34 1.68L2.18 5.83L6.34 9.97C6.62 10.25 6.62 10.69 6.34 10.96C6.07 11.23 5.63 11.23 5.35 10.96L0.7 6.32C0.43 6.05 0.43 5.61 0.7 5.34L5.35 0.7C5.63 0.43 6.07 0.43 6.34 0.7Z"
          fill="#484964"
          fillOpacity="1.000000"
          fillRule="evenodd"
        />
        <path
          id="Vector (Stroke)"
          d="M6.34 0.7C6.07 0.43 5.63 0.43 5.35 0.7L0.7 5.34C0.43 5.61 0.43 6.05 0.7 6.32L5.35 10.96C5.63 11.23 6.07 11.23 6.34 10.96C6.62 10.69 6.62 10.25 6.34 9.97L2.18 5.83L6.34 1.68C6.62 1.41 6.62 0.97 6.34 0.7Z"
          stroke="#484964"
          strokeOpacity="1.000000"
          strokeWidth="1.000000"
          strokeLinejoin="round"
        />
        <path
          id="Vector (Stroke)"
          d="M12.29 0.7C12.56 0.97 12.56 1.41 12.29 1.68L8.13 5.83L12.29 9.97C12.56 10.25 12.56 10.69 12.29 10.96C12.02 11.23 11.58 11.23 11.3 10.96L6.65 6.32C6.37 6.05 6.37 5.61 6.65 5.34L11.3 0.7C11.58 0.43 12.02 0.43 12.29 0.7Z"
          fill="#484964"
          fillOpacity="1.000000"
          fillRule="evenodd"
        />
        <path
          id="Vector (Stroke)"
          d="M12.29 0.7C12.02 0.43 11.58 0.43 11.3 0.7L6.65 5.34C6.37 5.61 6.37 6.05 6.65 6.32L11.3 10.96C11.58 11.23 12.02 11.23 12.29 10.96C12.56 10.69 12.56 10.25 12.29 9.97L8.13 5.83L12.29 1.68C12.56 1.41 12.56 0.97 12.29 0.7Z"
          stroke="#484964"
          strokeOpacity="1.000000"
          strokeWidth="1.000000"
          strokeLinejoin="round"
        />
      </svg>
    </a>
    <a href="" className="pagination__item prev">
      <svg
        width="24.000000"
        height="24.000000"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <path
          id="Vector"
          d="M14 16L9.75 11.75L14 7.51"
          stroke="#484964"
          strokeOpacity="1.000000"
          strokeWidth="2.000000"
          strokeLinejoin="round"
          strokeLinecap="round"
        />
      </svg>
    </a>
    <a href="" className="pagination__item active">
      1000
    </a>
    <a href="" className="pagination__item">
      2
    </a>
    <a href="" className="pagination__item">
      3
    </a>
    <a href="" className="pagination__item sep">
      ...
    </a>
    <a href="" className="pagination__item">
      99
    </a>
    <a href="" className="pagination__item">
      100
    </a>
    <a href="" className="pagination__item next">
      <svg
        width="24.000000"
        height="24.000000"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <path
          id="Vector"
          d="M10 8L14.24 12.24L10 16.48"
          stroke="#484964"
          strokeOpacity="1.000000"
          strokeWidth="2.000000"
          strokeLinejoin="round"
          strokeLinecap="round"
        />
      </svg>
    </a>
    <a href="" className="pagination__item last">
      <svg
        width="13.000000"
        height="11.666748"
        viewBox="0 0 13 11.6667"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <path
          id="Vector (Stroke)"
          d="M6.65 10.96C6.37 10.69 6.37 10.25 6.65 9.97L10.81 5.83L6.65 1.68C6.37 1.41 6.37 0.97 6.65 0.7C6.92 0.43 7.36 0.43 7.64 0.7L12.29 5.34C12.56 5.61 12.56 6.05 12.29 6.32L7.64 10.96C7.36 11.23 6.92 11.23 6.65 10.96Z"
          fill="#484964"
          fillOpacity="1.000000"
          fillRule="evenodd"
        />
        <path
          id="Vector (Stroke)"
          d="M6.65 10.96C6.92 11.23 7.36 11.23 7.64 10.96L12.29 6.32C12.56 6.05 12.56 5.61 12.29 5.34L7.64 0.7C7.36 0.43 6.92 0.43 6.65 0.7C6.37 0.97 6.37 1.41 6.65 1.68L10.81 5.83L6.65 9.97C6.37 10.25 6.37 10.69 6.65 10.96Z"
          stroke="#484964"
          strokeOpacity="1.000000"
          strokeWidth="1.000000"
          strokeLinejoin="round"
        />
        <path
          id="Vector (Stroke)"
          d="M0.7 10.96C0.43 10.69 0.43 10.25 0.7 9.97L4.86 5.83L0.7 1.68C0.43 1.41 0.43 0.97 0.7 0.7C0.97 0.43 1.41 0.43 1.69 0.7L6.34 5.34C6.62 5.61 6.62 6.05 6.34 6.32L1.69 10.96C1.41 11.23 0.97 11.23 0.7 10.96Z"
          fill="#484964"
          fillOpacity="1.000000"
          fillRule="evenodd"
        />
        <path
          id="Vector (Stroke)"
          d="M0.7 10.96C0.97 11.23 1.41 11.23 1.69 10.96L6.34 6.32C6.62 6.05 6.62 5.61 6.34 5.34L1.69 0.7C1.41 0.43 0.97 0.43 0.7 0.7C0.43 0.97 0.43 1.41 0.7 1.68L4.86 5.83L0.7 9.97C0.43 10.25 0.43 10.69 0.7 10.96Z"
          stroke="#484964"
          strokeOpacity="1.000000"
          strokeWidth="1.000000"
          strokeLinejoin="round"
        />
      </svg>
    </a>
  </div>
);
